import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog';
import { P } from '../ui/typography';

interface AvailabilityPastAlertProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  message?: string;
}

export function AvailabilityPastAlert({ open, onOpenChange, message }: AvailabilityPastAlertProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{message || 'You cannot alter availability that has already passed.'}</AlertDialogTitle>
          <AlertDialogDescription>
            Please contact the office for assistance.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onPress={() => onOpenChange(false)}>
            <P className="text-white">Cancel</P>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}